import React from 'react';
import ReactMarkdown from 'react-markdown';

const PreviewCard = (props) => {
  const color = props.color || 'green';

  function handleNavigation() {
    if (props.externalLink) {
      window.open(props.link, '_blank', 'noopener,noreferrer');
    } else {
      window.location.href = props.link;
    }
  };

  let accessibleLabel =
    props.ariaLabel || `Read more${props.title ? ` about ${props.title}` : ''}`;
  if (props.externalLink) {
    accessibleLabel += ' (opens in a new tab)';
  }

  return (
    <div className={`preview-card-link ${color} focus-on-light`}>
      <ReactMarkdown className="preview-card" source={props.content} />
      <button
        aria-label={accessibleLabel}
        className={`quill-button small contained focus-on-light ${color}`}
        onClick={handleNavigation}
        role="link"
      >
        {props.buttonText || 'Read'}
      </button>
    </div>
  );
};

export default PreviewCard;
